export const SESSION_STATUS = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  DISCARDED: 'DISCARDED',
} as const);

export type SessionStatus = (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS];
